import { useState } from "react";
import axios from "axios";
import { STATUSES, fmtDate, toLocalInput } from "./leadUtils";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StatusPicker = ({ value, onChange }) => (
  <div>
    <label className="block font-sans-ui text-[10px] tracking-mega text-ink/50 mb-2">STATO</label>
    <div className="flex flex-wrap gap-2">
      {STATUSES.map((s) => (
        <button
          key={s.key}
          data-testid={`lead-status-${s.key}`}
          onClick={() => onChange(s.key)}
          className={`font-sans-ui text-[10px] tracking-mega px-3 py-2 border transition-colors ${value === s.key ? "bg-ink text-ivory border-ink" : "hairline text-ink/60 hover:border-ink"}`}
        >
          {s.label.toUpperCase()}
        </button>
      ))}
    </div>
  </div>
);

const FollowUpPicker = ({ value, onChange, lead }) => {
  const hint = lead.follow_up_sent && lead.follow_up_at
    ? `Promemoria inviato il ${fmtDate(lead.follow_up_sent_at)}.`
    : "Riceverai un'email all'orario indicato con i dati del lead.";
  return (
    <div>
      <label className="block font-sans-ui text-[10px] tracking-mega text-ink/50 mb-2">RICHIAMO (PROMEMORIA EMAIL)</label>
      <div className="flex items-center gap-2">
        <input
          data-testid="lead-follow-up-input"
          type="datetime-local"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="bg-white border hairline px-3 py-2 font-sans-ui text-sm focus:border-ink focus:outline-none"
        />
        {value && (
          <button type="button" data-testid="lead-follow-up-clear" onClick={() => onChange("")} className="font-sans-ui text-[10px] tracking-mega text-ink/50 hover:text-destructive transition-colors">RIMUOVI</button>
        )}
      </div>
      <p data-testid="lead-follow-up-hint" className="mt-2 font-sans-ui text-[11px] text-ink/45 leading-relaxed">{hint}</p>
    </div>
  );
};

export const LeadEditor = ({ lead, token, onUpdated }) => {
  const [status, setStatus] = useState(lead.status || "nuovo");
  const [notes, setNotes] = useState(lead.notes || "");
  const [followUp, setFollowUp] = useState(toLocalInput(lead.follow_up_at));
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  const save = async () => {
    setSaving(true);
    setMsg("");
    try {
      const body = { status, notes };
      if (followUp !== toLocalInput(lead.follow_up_at)) body.follow_up_at = followUp ? new Date(followUp).toISOString() : "";
      const { data } = await axios.patch(`${API}/admin/leads/${lead.id}`, body, { headers: { Authorization: `Bearer ${token}` } });
      onUpdated(data);
      setMsg("Salvato.");
    } catch (e) {
      setMsg(e.response?.data?.detail || "Errore nel salvataggio.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="grid sm:grid-cols-[1fr_1.4fr] gap-6 bg-linen p-5 mb-8">
      <div className="space-y-6">
        <StatusPicker value={status} onChange={setStatus} />
        <FollowUpPicker value={followUp} onChange={setFollowUp} lead={lead} />
      </div>
      <div>
        <label className="block font-sans-ui text-[10px] tracking-mega text-ink/50 mb-2">NOTA INTERNA</label>
        <textarea
          data-testid="lead-notes-input"
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Esito della chiamata, prossimi passi..."
          className="w-full bg-white border hairline p-3 font-sans-ui text-sm resize-none focus:border-ink focus:outline-none"
        />
        <div className="flex items-center gap-4 mt-3">
          <button data-testid="lead-save-button" onClick={save} disabled={saving} className="bg-ink text-ivory px-5 py-2.5 text-[10px] tracking-mega font-semibold hover:bg-charcoal transition-colors disabled:opacity-50">
            {saving ? "SALVATAGGIO..." : "SALVA"}
          </button>
          {msg && <span data-testid="lead-save-message" className="font-sans-ui text-xs text-ink/60">{msg}</span>}
          {lead.status_updated_at && <span className="font-sans-ui text-[11px] text-ink/40 ml-auto">Agg. {lead.status_updated_at.slice(0, 16).replace("T", " ")}</span>}
        </div>
      </div>
    </div>
  );
};
